import React from "react";
/* Icon components */

const Icons = (props) => {
  return (
    <div className="icons">
      <img className="heart-button" src="icons/heart.svg" alt="heart" />
      <img className="play-button" src="icons/play.svg" alt="play" />
      <img className="dots-button" src="icons/dots.svg" alt="dots" />
    </div>
  );
};

export default Icons;
